const set = require('regenerate')(0x2BC, 0x2CD, 0x11FB0);
set.addRange(0x300A, 0x300B).addRange(0xA4D0, 0xA4FF);
exports.characters = set;
